/*global sendTransaction, storage */

var myDataLayer = {
    insuranceHandler: $('.ga-insurance-item'),
    extrasHandler: $('.ga-extra-item'),
    category: (Object.prototype.hasOwnProperty.call(_d, 'a') ? _d.a.country + '/' + _d.a.city + '/' + _d.a.location + '/' + _d.a.dropCountry + '/' + _d.a.dropCity + '/' + _d.a.dropLocation : 'unknown'),
    storagePrefix: 'dataLayer-',
    init: function() {

        // Search Page CTA (PDP detail) - Book Now
        $(document).on('click', '.click-on-car', function() {
            var that = $(this),
                id = that.data('sipp'),
                name = that.data('name'),
                position = that.data('event-action'),
                brand = that.data('brand');

            try {
                window.dataLayer.push({
                    event: 'eec.impressionClick',
                    ecommerce: {
                        click: {
                            actionField: {
                                list: 'Search Results'
                            },
                            products: [{
                                id: id,
                                name: name,
                                brand: brand,
                                category: myDataLayer.category,
                                variant: '',
                                list: 'Search results',
                                position: position
                            }]
                        }
                    }
                });
            } catch (err) {}
        });


        if (_d.page === 'booking-index') {

            if (Object.prototype.hasOwnProperty.call(_d.a, 'addedToBasket')) {

                try {

                    if (myDataLayer.getProducts() !== null) {
                        window.dataLayer.push({
                            event: 'eec.remove',
                            ecommerce: {
                                remove: {
                                    actionField: {
                                        list: 'PDP'
                                    },
                                    products: myDataLayer.getProducts()
                                }
                            }
                        });

                        myDataLayer.removeProducts();
                    }

                } catch (err) {}
            }

            var productImpressions = [];

            this.insuranceHandler.each(function() {
                var that = $(this);

                if (that.is(':visible')) {
                    productImpressions.push({
                        id: that.data('id').toString(),
                        name: that.data('name')
                    });
                }
            });

            this.extrasHandler.each(function() {
                var that = $(this);

                productImpressions.push({
                    id: that.data('id'),
                    name: that.data('name')
                });
            });

            try {
                // Booking Page - Product detail
                window.dataLayer.push({
                    event: 'eec.detail',
                    ecommerce: {
                        detail: {
                            actionField: {
                                list: 'PDP'
                            },
                            products: [{
                                id: _d.a.sipp,
                                name: _d.a.name,
                                brand: _d.a.brand,
                                category: myDataLayer.category,
                                variant: ''
                            }]
                        }
                    }
                });

                window.dataLayer.push({
                    event: 'eec.impressionViewPDP',
                    ecommerce: {
                        impressions: productImpressions
                    }
                });
            } catch (err) {}
        }

        if (_d.page === 'reservation-payment') {
            window.dataLayer.push({
                event: 'eec.checkout',
                ecommerce: {
                    checkout: {
                        actionField: {
                            step: 2
                        },
                        products: myDataLayer.getProducts()
                    }
                }
            });
        }

        if (_d.page === 'reservation-show') {
            // Confirmation page
            // Transaction variables (pushed on transaction data being available)

            if (typeof sendTransaction !== 'undefined' && sendTransaction) {
                var products = [];

                products.push({
                    id: _d.a.sipp,
                    name: _d.a.name,
                    brand: _d.a.brand,
                    category: myDataLayer.category,
                    variant: '',
                    quantity: '1',
                    price: _d.a.carPrice
                });

                if (Object.prototype.hasOwnProperty.call(_d.a, 'insurances') && _d.a.insurances.length > 0) {

                    for (var i = 0; i < _d.a.insurances.length; i++) {
                        products.push(_d.a.insurances[i]);
                    }

                }

                if (Object.prototype.hasOwnProperty.call(_d.a, 'extras') && _d.a.extras.length > 0) {

                    for (var j = 0; j < _d.a.extras.length; j++) {
                        products.push(_d.a.extras[j]);
                    }

                }

                try {
                    window.dataLayer.push({
                        event: 'eec.purchase',
                        ecommerce: {
                            currencyCode: _d.a.currency,
                            purchase: {
                                actionField: {
                                    id: _d.rn,
                                    affiliation: 'DCH',
                                    revenue: _d.a.revenue,
                                    tax: '0.00',
                                    shipping: '0.00',
                                    coupon: ''
                                },
                                products: products
                            }
                        }
                    });

                    myDataLayer.removeProducts();
                } catch (err) {}

                //this block needs for reactNative application to handle revenue data
                try {
                    if (Object.prototype.hasOwnProperty.call(_d, 'rn') && Object.prototype.hasOwnProperty.call(_d, 'a') && Object.prototype.hasOwnProperty.call(_d.a, 'currency') && Object.prototype.hasOwnProperty.call(_d.a, 'revenue')) {
                        if (Object.prototype.hasOwnProperty.call(window, 'ReactNativeWebView')
                            && Object.prototype.hasOwnProperty.call(window.ReactNativeWebView, 'postMessage')
                            && typeof window.ReactNativeWebView.postMessage === 'function') {
                            window.ReactNativeWebView.postMessage(JSON.stringify({
                                event: 'successful_purchase', payload: {
                                    booking_id: _d.rn,
                                    revenue: _d.a.revenue,
                                    currency: _d.a.currency
                                }
                            }));
                        }
                    }
                } catch (err) {
                    /* eslint-disable no-console */
                    console.log('successful_purchase event sending error(desktop)');
                    console.log(err);
                    /* eslint-enable no-console */
                }
            }
        }
    },
    send: function(type, options) {
        options = (typeof options !== 'undefined') ? options : [];

        if (type === 'booking') {
            var products = [];

            products.push({
                id: _d.a.sipp,
                name: _d.a.name,
                brand: _d.a.brand,
                category: myDataLayer.category,
                variant: '',
                quantity: '1'
            });

            this.insuranceHandler.each(function() {
                var that = $(this);

                if (that.is(':visible') && $('#'+ that.data('input-id')).is(':checked')) {
                    products.push({
                        id: that.data('id').toString(),
                        name: that.data('name'),
                        quantity: '1'
                    });
                }
            });

            this.extrasHandler.each(function() {
                var that = $(this);

                if (that.val() > 0) {
                    products.push({
                        id: that.data('id'),
                        name: that.data('name'),
                        quantity: that.val()
                    });
                }
            });

            try {
                // Booking Page - PDP CTA - Book Now (add to basket)
                window.dataLayer.push({
                    event: 'eec.add',
                    ecommerce: {
                        add: {
                            actionField: {
                                list: 'PDP'
                            },
                            products: products
                        }
                    }
                });

                myDataLayer.setProducts(products);
            } catch (err) {}

            try {
                // Booking Page - Book Now CTA (checkout start)
                window.dataLayer.push({
                    event: 'eec.checkout',
                    ecommerce: {
                        checkout: {
                            actionField: {
                                step: 1
                            },
                            products: products
                        }
                    }
                });

                myDataLayer.setProducts(products);
            } catch (err) {}
        }

        if (type === 'submitted-booking-form') {

            try {
                window.dataLayer.push({
                    'event': 'submittedBookingForm'
                });
            } catch (err) {}
        }

        if (type === 'sticky-search-box') {
            dataLayer.push({
                'stickySearchBox': {
                    'action': options.action
                },
                'event': 'stickySearchBox'
            });
        }

        if (type === 'search-box') {
            dataLayer.push({
                'searchBox': {
                    'action': options.action
                },
                'event': 'searchBox'
            });
        }

        if (type === 'change-search') {
            dataLayer.push({
                'changeSearchData': {
                    'action': options.action
                },
                'event': 'changeSearchData'
            });
        }

        if (type === 'selected-extras-count') {

            var extrasCount = 0;
            $('.ga-extra-item').each(function() {
                if ($(this).val() > 0) {
                    extrasCount++;
                }
            });

            if (extrasCount > 0) {
                try {
                    window.dataLayer.push({
                        'selectedExtrasCount': {
                            'count': extrasCount
                        },
                        'event': 'selectedExtrasCount'
                    });
                } catch (err) {}
            }
        }


        if (type === 'payment') {
            try {

                var paymentMethod = options.paymentMethod;

                // Payment Page CTA - Book Now - checkout complete
                window.dataLayer.push({
                    event: 'eec.checkout',
                    ecommerce: {
                        checkout: {
                            actionField: {
                                step: 2,
                                option: myDataLayer.capitalizeFirstLetter(paymentMethod)
                            },
                            products: myDataLayer.getProducts()
                        }
                    }
                });
            } catch (err) {}
        }

        if (type === 'post-affiliate') {

            try {
                window.dataLayer.push({
                    'event': 'PostAffiliate_Click'
                });
            } catch (err) {}
        }

        if (type === 'marketing-checkbox') {

            try {
                window.dataLayer.push({
                    'event': 'marketingCheckbox'
                });
            } catch (err) {}
        }

        if (type === 'payment-error') {

            try {
                window.dataLayer.push({
                    'paymentError': {
                        'label': options.fieldName
                    },
                    'event': 'paymentError'
                });
            } catch (err) {}
        }

    },
    sendImpressionEvent: function(productBatch, eventName) {
        window.dataLayer.push({
            event: 'eec.' + eventName,
            ecommerce: {
                impressions: productBatch
            }
        });
    },
    setProducts: function(obj) {
        storage.save(myDataLayer.storagePrefix + _d.a.sipp, obj);
    },
    getProducts: function() {
        if (typeof _d.a.sipp === 'undefined') {
            for (let key in localStorage) {
                if (key.substring(0, 10) === myDataLayer.storagePrefix) {
                    return storage.get(key);
                }
            }
        }

        return storage.get(myDataLayer.storagePrefix + _d.a.sipp);
    },
    removeProducts: function() {
        for (let key in localStorage) {
            if (key.substring(0, 10) === myDataLayer.storagePrefix) {
                storage.delete(key);
            }
        }
    },
    capitalizeFirstLetter: function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    prepareUrl: function(string) {
        return string.replace(/\s+/g, '-').toLowerCase();
    }
};
